<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.organization.selected_organization' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
@if(organizations?.length > 0){
    <div class="overflow-y-auto zuper-scrollbar data-picker-list-content-height">
        @if(associatedOrganizations?.length > 0 && isFromNote){
            <div class="flex justify-between items-center" [ngClass]="{'border-b border-gray-200': !isAssociatedExpanded}">
                <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                    @if(associatedOrganizations.length > 1){
                        {{'text.organizations' | translate}}
                    } @else{
                        {{'text.organization' | translate}}
                    }
                    {{ notesPickerPreferences[module].label | translate}}
                </div>
                <div class="relative cursor-pointer py-3 px-5 flex items-center space-x-2 text-gray-700 transition-all"
                    (click)="isAssociatedExpanded = !isAssociatedExpanded"
                    [ngClass]="{ 'custom-expanded-top': isAssociatedExpanded }">
                    <div class="flex flex-col items-center text-blue-500">
                        <ng-container *ngIf="!isAssociatedExpanded">
                            <i class="text-base font-medium leading-6 ti ti-chevron-up rotate-180"></i>
                            <i class="-mt-3 text-base font-medium leading-6 ti ti-chevron-down rotate-180"></i>
                        </ng-container>
                        <ng-container *ngIf="isAssociatedExpanded">
                            <i class="text-base font-medium leading-6 ti ti-chevron-up"></i>
                            <i class="-mt-3 text-base leading-6 font-medium ti ti-chevron-down"></i>
                        </ng-container>
                    </div>
                    <span class="text-base font-medium text-blue-500">
                        {{ isAssociatedExpanded ? ('collapse' | translate) : ('expand' | translate) }}
                    </span>
                </div>
            </div>
            @if(isAssociatedExpanded){
                <ul role="list" class="border-b border-gray-200">
                    <li class="organization-data-picker-list-ele border-b border-gray-200" *ngFor="let organization of associatedOrganizations;let index = index">
                        <ng-container *ngTemplateOutlet="organizationTemplate; context: { organization: organization,index: index, isAssociated: true }"></ng-container>
                    </li>
                </ul>
            }
            <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                {{'text.picker.association.all.organizations' | translate}}
            </div>
        }
        @if(notesPickerPreferences[module]?.preference?.organization === 'LINKED' && isFromNote){
            <div class="text-base primary-font font-normal text-gray-500 py-3 px-5">
                @if(organizations.length > 0){
                    {{'text.organizations' | translate}}
                } @else{
                    {{'text.organization' | translate}}
                }
                {{ notesPickerPreferences[module].label | translate}}
            </div>
        }
        <ul role="list" class="divide-y divide-gray-200 " [ngClass]="{ 'data-picker-max-count': isMaxSelectionLimit }"
            *ngIf="organizations.length">
            <li class="organization-data-picker-list-ele" *ngFor="let organization of organizations;let index = index">
                <ng-container *ngTemplateOutlet="organizationTemplate; context: { organization: organization,index: index, isAssociated: false }"></ng-container>
            </li>
        </ul>
    </div>
}

<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!organizations.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_organization_found.svg" alt="No Organizations Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.organization.not_found' |
            translate}} '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.organization.placeholder' |
            translate}}
        </h4>
    </div>
</div>

<ng-template #organizationTemplate let-organization="organization" let-index="index" let-isAssociated="isAssociated">
    <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5 w-full"
    [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
    (click)="selectOption === 'readOnly' ? viewOrganizationDetails($event, organization.organization_uid) : null">
    <a class="-m-1 block flex-1 p-1 picker-data-parent-container">
        <div class="relative flex min-w-0 flex-1 items-center">
            <div class="picker-data-inner-container flex" *ngIf="selectOption === 'multiSelect'">
                <span class="flex items-center flex justify-center px-1">
                    <input type="checkbox" class="picker-data-selection-size" [id]="isAssociated ? 'org_data_select_associated_' + index : 'org_data_select_' + index"
                        (change)="selectOrganization($event, organization)" [checked]="isSelectedOrganization(organization)" />
                </span>
                <div class="ml-4 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="organizationsContent"></ng-container>
                </div>
            </div>
            <div class="picker-data-inner-container flex" *ngIf="selectOption === 'select'">
                <span class="flex items-center flex justify-center px-1">
                    <input type="radio" class="picker-data-selection-size" [id]="isAssociated ? 'org_data_select_associated_' + index : 'org_data_select_' + index"
                        (change)="selectOrganization($event, organization)" [checked]="isSelectedOrganization(organization)" />
                </span>
                <div class="ml-4 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="organizationsContent"></ng-container>
                </div>
            </div>
            <ng-container *ngIf="selectOption === 'readOnly'">
                <div class="ml-2 truncate picker-data-value-content">
                    <ng-container *ngTemplateOutlet="organizationsContent"></ng-container>
                </div>
            </ng-container>
            <ng-template #organizationsContent>
            <div class="w-full flex flex-col">
                <label class="truncate text-lg font-medium text-gray-900 cursor-pointer" [for]="isAssociated ? 'org_data_select_associated_' + index : 'org_data_select_' + index">
                    {{organization.organization_name}}
                </label>
                <label *ngIf="organization.organization_email" class="truncate text-base text-gray-500">
                    {{organization.organization_email}}
                </label>
            </div>
            </ng-template>
            <button mat-icon-button class="cursor-pointer ml-auto"
                matTooltip="{{ updateArrowTooltipText(organization.organization_uid, isAssociated) | translate }}"
                matTooltipPosition="left" *ngIf="!showSpinLoading(organization.organization_uid, isAssociated)"
                [ngClass]="rotateArrowIcon(organization.organization_uid, isAssociated)"
                (click)="viewOrganizationDetails($event, organization.organization_uid, isAssociated)">
                <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                    data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down" width="24"
                        height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none">
                        </path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </mat-icon>
            </button>
            <div class="ml-auto py-2.5 h-10" *ngIf="showSpinLoading(organization.organization_uid, isAssociated)">
                <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px">
                </mat-spinner>
            </div>
        </div>
    </a>
</div>
<div class="p-4 bg-gray-100"
    *ngIf="(('org_details_' + organization.organization_uid === orgEleId && !isAssociated) || ('org_details_associated_' + organization.organization_uid === orgEleId && isAssociated)) && organizationDetails && !isSpinLoading">
    <div class="bg-card rounded relative">
        <a target="_blank" class="hidden" #orgViewFullDetails
            href="{{viewOrganizationFullDetails(organization.organization_uid)}}"></a>
        <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="orgViewFullDetails.click($event)"
            matTooltip="{{'text.view_details.new_tab' | translate}}"
            matTooltipPosition="left">
            <button mat-icon-button>
                <mat-icon class="text-xl">open_in_new</mat-icon>
            </button>
        </span>
        <div class="text-base">
            <div class="px-2 truncate flex flex-wrap">
                <div *ngIf="organizationDetails.organization_description"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer organization-details-fields dark:bg-hover w-full">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'description' | translate}} </p>
                    <div class="mt-1 text-gray-900 inner-html-overflow"
                        [innerHTML]="organizationDetails.organization_description | safeHtml"></div>
                </div>
                <div
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer organization-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                      {{'dataPicker.organization.content.noOfCustomers' | translate}}
                    </p>
                    <p class="mt-1 text-gray-900">
                        {{organizationDetails.no_of_customers}}</p>
                </div>
                <div *ngIf="organizationDetails.organization_timezone_value"
                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer customer-details-fields dark:bg-hover flex-item-wrap">
                <p class="font-medium leading-5 truncate text-gray-500">
                    {{'preferred.timezone' | translate}} </p>
                <p class="mt-1 text-gray-900 text-wrap">
                    {{organizationDetails.organization_timezone_value}}</p>
                </div>
                <div
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer organization-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'status.text' | translate}} </p>
                    <div class="mt-2">
                        <badge [options]="getStatusBadgeOptions(organizationDetails.is_active ? 'ACTIVE' : 'INACTIVE', (organizationDetails.is_active ? 'active.text' :
                                                        'text.inactive')
                                                        |
                                                        translate)">
                        </badge>
                    </div>
                </div>
                <div *ngIf="organizationDetails.created_at"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer organization-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'created.at.text' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                        {{organizationDetails.created_at | datetime}}</p>
                </div>
                <div *ngIf="organizationDetails.created_by && organizationDetails.created_by.first_name"
                    class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer organization-details-fields dark:bg-hover flex-item-wrap">
                    <p class="font-medium leading-5 truncate text-gray-500">
                        {{'created.by.text' | translate}} </p>
                    <p class="mt-1 text-gray-900">
                        {{organizationDetails.created_by.first_name}}
                        {{organizationDetails.created_by.last_name}}</p>
                </div>
            </div>
        </div>
        <div class="px-2 py-2 border-t text-base"
            *ngIf="organizationDetails.organization_address && (organizationDetails.organization_address.street || organizationDetails.organization_address.state)">
            <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                {{'dataPicker.organization.content.organization_address' | translate}} </p>
            <div class="px-3">
                <p *ngIf="organizationDetails.organization_address.street" class="text-base mb-2">
                    {{organizationDetails.organization_address.street}}</p>
                <p *ngIf="organizationDetails.organization_address.landmark" class="text-base mb-2">
                    {{organizationDetails.organization_address.landmark}}</p>
                <p *ngIf="organizationDetails.organization_address.city" class="text-base mb-2">
                    {{organizationDetails.organization_address.city}}</p>
                <p *ngIf="organizationDetails.organization_address.state" class="text-base mb-2">
                    {{organizationDetails.organization_address.state}}
                    {{organizationDetails.organization_address.zip_code ? '- ' +
                    organizationDetails.organization_address.zip_code : '' }}</p>
                <p *ngIf="organizationDetails.organization_address.country" class="text-base">
                    {{organizationDetails.organization_address.country}}</p>
            </div>
        </div>
        <div class="px-2 py-2 border-t text-base"
            *ngIf="organizationDetails.organization_billing_address && (organizationDetails.organization_billing_address.street || organizationDetails.organization_billing_address.state)">
            <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                {{'billing.address.text' | translate}} </p>
            <div class="px-3">
                <p *ngIf="organizationDetails.organization_billing_address.street" class="text-base mb-2">
                    {{organizationDetails.organization_billing_address.street}}</p>
                <p *ngIf="organizationDetails.organization_billing_address.landmark" class="text-base mb-2">
                    {{organizationDetails.organization_billing_address.landmark}}</p>
                <p *ngIf="organizationDetails.organization_billing_address.city" class="text-base mb-2">
                    {{organizationDetails.organization_billing_address.city}}</p>
                <p *ngIf="organizationDetails.organization_billing_address.state" class="text-base mb-2">
                    {{organizationDetails.organization_billing_address.state}}
                    {{organizationDetails.organization_billing_address.zip_code ? '- ' +
                    organizationDetails.organization_billing_address.zip_code : '' }}</p>
                <p *ngIf="organizationDetails.organization_billing_address.country" class="text-base">
                    {{organizationDetails.organization_billing_address.country}}</p>
            </div>
        </div>
    </div>
</div>
</ng-template>